import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import LinkElement from './LinkElement';
import useContentElement from '../../hooks/useContentElement';

export default function ButtonElement(props) {
  let {
    // eslint-disable-next-line prefer-const
    data, variant, color, ...otherProps
  } = props;
  const { elementData } = useContentElement(
    data,
    ButtonElement.dataSchema,
  );

  // Set default values
  const { link } = elementData;
  const label = elementData.label ?? '';
  color = elementData.color ?? color ?? null;

  if (variant === 'outlined' && (!color || color === 'primary')) {
    variant = 'contained';
    color = 'primary';
  }

  return (
    <LinkElement data={link} onClick={otherProps.onClick}>
      <Button
        {...otherProps}
        color={color}
        component="a"
        variant={variant}
      >
        {label}
      </Button>
    </LinkElement>
  );
}

ButtonElement.typeName = 'ButtonElement'; // Strapi element type
ButtonElement.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    color: PropTypes.string,
    link: LinkElement.propTypes.isRequired,
  }).isRequired,
};

ButtonElement.graphQlSchema = `
  id
  label
  color
  link {
    ${LinkElement.graphQlSchema}
  }
`;
